import z from "zod";

import { SIZES } from "@frontend/styles/constants";

import {
  DATA_TABLE_SCROLLS,
  DATA_TABLE_SPACINGS,
  DATA_TABLE_VARIANTS,
} from "./constants";

const booleanAttribute = z
  .string()
  .optional()
  .transform((value) => value !== undefined && value !== "false");

// Left undefined when absent, so the variant keeps deciding the frame
const optionalBooleanAttribute = z
  .string()
  .optional()
  .transform((value) => (value === undefined ? undefined : value !== "false"));

export const dataTableDataSchema = z.object({
  size: z.enum(SIZES).optional(),
  variant: z.enum(DATA_TABLE_VARIANTS).optional(),
  loading: booleanAttribute,
  loadingRowCount: z.coerce.number().optional(),
  loadingRowHeight: z.string().optional(),
  bordered: optionalBooleanAttribute,
  columnBorders: booleanAttribute,
  striped: booleanAttribute,
  scroll: z.enum(DATA_TABLE_SCROLLS).optional(),
  maxHeight: z.string().optional(),
  stickyHeader: booleanAttribute,
  stickyOffset: z.string().optional(),
  stickyColumn: booleanAttribute,
  horizontalSpacing: z.enum(DATA_TABLE_SPACINGS).optional(),
  verticalSpacing: z.enum(DATA_TABLE_SPACINGS).optional(),
  emptyMessage: z.string().optional(),
  rowId: z.string().optional(),
  selectable: booleanAttribute,
  enableMultiRowSelection: optionalBooleanAttribute,
  selectOnRowClick: booleanAttribute,
});

export type DataTableDataProps = z.infer<typeof dataTableDataSchema>;
